import Vue from 'vue'
import VueRouter from 'vue-router'
import PlayerLevels from '../views/PlayerLevels.vue'
import DailyPuzzles from '../views/DailyPuzzles.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/', redirect: '/daily-puzzles' },
    {
      path: '/daily-puzzles',
      name: 'DailyPuzzles',
      component: DailyPuzzles,
      meta: { title: '每日一关' }
    },
    {
      path: '/player-levels',
      name: 'PlayerLevels',
      component: PlayerLevels,
      meta: { title: '玩家关卡' }
    }
  ]
})

router.afterEach((to) => {
  if (to.meta && to.meta.title) {
    document.title = `${to.meta.title} · 拼图后台`
  }
})

export default router
